import { Component } from '@angular/core';

import { BaseScorecardComponent } from '../base/_base-scorecard.component';


@Component({
  moduleId: module.id,
  selector: 'custom-fields-scorecard',
  templateUrl: 'custom-fields-scorecard.component.html',
})
export class CustomFieldsScorecardComponent extends BaseScorecardComponent {
}
